import { forwardRef } from "react";
import { Stack, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import GraphicEqOutlinedIcon from "@mui/icons-material/GraphicEqOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import FormSection from "../../../Forms/FormSection/form-section";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { ShareFormValues } from "../modal-create-share";
import moment from "moment";
import { ObjectLayer } from "../../../../Core/Api/Types/object-layer";
import ClosedCaptionOutlinedIcon from "@mui/icons-material/ClosedCaptionOutlined";
import { useTranslation } from "react-i18next";

export type ModalCreateShareStepThreeElementProps = {
  formValues: ShareFormValues;
  securityText: string[];
};

const ModalCreateShareStepThree = forwardRef<any, ModalCreateShareStepThreeElementProps>((props, ref) => {
  const { t } = useTranslation();
  const { formValues, securityText } = props;

  return (
    <>
      <Typography variant="h5" fontWeight={600} mt={2} mb={2}>
        {t("modal:modalCreateShareStepFour.body.checkYourShareOptions")}
      </Typography>
      <Stack spacing={1}>
        {formValues.stepOne.objectLayer !== ObjectLayer.Asset && formValues.assetIds.length === 0 && (
          <FormSection
            defaultExpanded={false}
            expanded={false}
            icon={<LanguageOutlinedIcon />}
            title={t("common:localization")}
            status={"todo"}
            statusText={[
              formValues.localizationSection.localizationAudioSelected.length > 0
                ? [
                    <GraphicEqOutlinedIcon sx={{ verticalAlign: "bottom" }} />,
                    " ",
                    formValues.localizationSection.localizationAudioSelected.map((element) => element.value).join(", "),
                  ]
                : "",
              formValues.localizationSection.localizationAudioSelected.length > 0 &&
              formValues.localizationSection.localizationSubtitlesSelected.length > 0
                ? " · "
                : "",
              formValues.localizationSection.localizationSubtitlesSelected.length > 0
                ? [
                    <ClosedCaptionOutlinedIcon sx={{ verticalAlign: "bottom" }} />,
                    " ",
                    formValues.localizationSection.localizationSubtitlesSelected
                      .map((element) => element.value)
                      .join(", "),
                  ]
                : "",
            ]}
          />
        )}
        <FormSection
          defaultExpanded={false}
          expanded={false}
          icon={<SettingsOutlinedIcon />}
          title={t("form:section.title.shareSettings")}
          status={"todo"}
          statusText={[
            formValues.settingsSection.shareName || t("form:helper.noShareName"),
            moment().add(formValues.settingsSection.expirationDate, "days").format("L"),
            t("form:helper.maxViews") + formValues.settingsSection.maxViews,
            formValues.settingsSection.comment || t("form:helper.noComment"),
          ].join(" · ")}
        />
        <FormSection
          defaultExpanded={false}
          expanded={false}
          icon={<LockOutlinedIcon />}
          title={t("common:security")}
          status={"todo"}
          statusText={securityText.join(" · ")}
        />
        <FormSection
          defaultExpanded={false}
          expanded={false}
          icon={<PersonOutlineOutlinedIcon />}
          title={t("common:recipients")}
          status={"todo"}
          statusText={formValues.recipientsSection.emails.join(" · ")}
        />
      </Stack>
    </>
  );
});

export default ModalCreateShareStepThree;
